"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function () {
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: narrativeRef,
    isVisible: narrativeVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: asideRef,
    isVisible: asideVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const dataPoints = ["EST. 1998", "PRECISION", "24/7 PRODUCTION", "100% ACCURACY"];
  return <section data-section-id="4308" id="direct-answer-block" className="bg-background text-foreground pt-32 md:pt-44 lg:pt-[180px] pb-24 md:pb-32 lg:pb-[140px] px-6 md:px-10 lg:px-16 overflow-hidden">
      <div className="max-w-[1440px] mx-auto">
        {}
        <div className="font-mono text-[11px] tracking-widest text-muted-foreground mb-16 md:mb-20 lg:mb-24 uppercase">
          / ABOUT / 01 — OUR LEGACY
        </div>

        {}
        <div ref={headlineRef} className={`mb-20 md:mb-28 lg:mb-32 transition-all duration-1000 ${headlineVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-default font-bold text-[14vw] md:text-[12vw] lg:text-[140px] leading-[0.95] tracking-tight uppercase">
            <span className="block">Engineered for</span>
            <span className="block font-serif italic font-normal normal-case tracking-tighter text-primary">
              Industrial Perfection.
            </span>
          </h2>
        </div>

        {}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          {}
          <div ref={narrativeRef} className={`lg:col-span-7 transition-all duration-1000 ${narrativeVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="space-y-10 md:space-y-12">
              <p className="font-default text-xl md:text-[22px] leading-[1.6] text-foreground/90">
                Before we became the industry standard for industrial marking, we were a small shop focused on solving the most complex labeling challenges for electrical contractors. We understood that in high-stakes environments, a label isn't just a piece of plastic—it's a critical safety component.
              </p>

              {}
              <blockquote className="py-6 md:py-8 border-y border-border">
                <p className="font-serif italic text-[28px] md:text-[36px] lg:text-[40px] leading-[1.15] tracking-tight text-primary">
                  <span className="text-foreground/40">&ldquo;</span>
                  We don't just print labels; we engineer permanent identification solutions that withstand the harshest conditions.
                  <span className="text-foreground/40">&rdquo;</span>
                </p>
              </blockquote>

              <p className="font-default text-xl md:text-[22px] leading-[1.6] text-foreground/90">
                Our evolution was driven by the needs of our clients. From UL 508A panel builders to large-scale utility providers, we refined our processes to ensure every phenolic tag, arc flash label, and direct part marking meets the most rigorous regulatory standards.
              </p>

              <p className="font-default text-xl md:text-[22px] leading-[1.6] text-foreground/90">
                Today, our facility utilizes state-of-the-art laser engraving and DPM technology to deliver precision-grade identification. We bridge the gap between complex engineering specifications and durable, compliant hardware. We don't just mark parts; we ensure total operational clarity.
              </p>
            </div>
          </div>

          {}
          <div ref={asideRef} className={`lg:col-span-4 lg:col-start-9 lg:mt-24 transition-all duration-1000 delay-200 ${asideVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="space-y-6">
              {}
              <div className="relative w-full overflow-hidden shadow-lg rounded-lg" style={{
              aspectRatio: "3 / 4"
            }}>
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/industrial_laser_engraving.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/industrial_laser_engraving.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1703715/img/industrial_laser_engraving.png-wvc-sizes" alt="Industrial laser engraving process" loading="lazy" decoding="async" className="w-full h-full object-cover grayscale" />
              </div>

              {}
              <div className="font-mono text-[11px] tracking-widest text-muted-foreground uppercase">— PRECISION LAB, 2026</div>

              {}
              <div className="h-px bg-border w-full" />

              {}
              
            </div>
          </div>
        </div>

        {}
        <div className="mt-24 md:mt-32 lg:mt-40 flex items-center gap-6">
          <div className="h-px flex-1 bg-border" />
          <div className="font-mono text-[11px] tracking-widest text-muted-foreground uppercase whitespace-nowrap">
            / Continued — Our Capabilities
          </div>
        </div>
      </div>
    </section>;
}